import $ from "jquery"

$(function() {
    /*
    const $menubutton = $("#menubutton");
    const $desktopmenu = $("#desktopmenu");
    const $body = $("body");
    $menubutton.on("click", function() {
        const newvisible = !$desktopmenu.hasClass("visible");
        $desktopmenu.toggleClass("visible", newvisible);
        $body.toggleClass("desktopmenuvisible", newvisible);
    });
    */

    const $mobilemenu = $("#mobilemenu");
    const $hamburger = $("#hamburger-mobilemenu");
    const $body = $("body");
    const $menubar = $mobilemenu.find(".menubar");
    const $menuitems = $mobilemenu.find(".menuitems");

    $hamburger.on("click", function() {
        toggleMobileMenu();
    });

    function toggleMobileMenu() {
        const mobileMenuVisible = $mobilemenu.hasClass("expanded");
        if(mobileMenuVisible) {
            hideMobileMenu();
        } else {
            showMobileMenu();
        }
    }

    function showMobileMenu() {
        hideAllDrawers();

        $mobilemenu.addClass("expanded");
        $hamburger.addClass("is-active");
        $body.addClass("mobilemenuvisible");

        const menuH = $menubar.outerHeight()+$menuitems.outerHeight();
        $mobilemenu.css("height", menuH+"px");
    }

    function hideMobileMenu() {
        $mobilemenu.removeClass("expanded");
        $hamburger.removeClass("is-active");
        $body.removeClass("mobilemenuvisible");

        $mobilemenu.css("height", "");
    }

    /*
    function enhanceHtml() {
        $mobilemenu.find("li.hassubmenu > a").append('<svg class="icon icon-arrowdown"><use xlink:href="#icon-arrowdown"></use></svg>');
    }
    enhanceHtml();
    */

    const $iconStatus = $menubar.find(".icon-malfunction-mobile");
    const $iconContact = $menubar.find(".icon-phone-mobile");
    //const $iconSearch = $menubar.find(".icon-search-mobile");
    const $drawerStatus = $(".drawer-status");
    const $drawerContact = $(".drawer-contact");
    $iconStatus.on("click", function() {
        hideMobileMenu();
        hideAllDrawersExcept($drawerStatus);
        $drawerStatus.toggleClass("visible");
    });
    $iconContact.on("click", function() {
        hideMobileMenu();
        hideAllDrawers();
        $drawerContact.toggleClass("visible");
    });
    function hideAllDrawers() {
        $(".drawer").removeClass("visible");
    }
    function hideAllDrawersExcept($exception) {
        $(".drawer").not($exception).removeClass("visible");
    }

    if($drawerStatus.hasClass("alwaysopen")) {
        hideAllDrawersExcept($drawerStatus);
        $drawerStatus.toggleClass("visible");
    }

    $("main, footer").on("click", function() {
        hideMobileMenu();
        hideAllDrawers();
    });
});
